import { IAutocompleteBaseOption } from 'transfix-ui/components/AutocompleteBase'
import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { $enum } from 'ts-enum-util'
import { DATE_RANGE_OPTIONS, MODE_OPTIONS_INTERMODAL } from 'apps/tms/constants/filters'
import { LOADING_METHOD_OPTIONS } from 'apps/tms/utils/loadingMethod'
import { GetFacilitiesAnalyticsQueryParams as FacilitiesQueryParams } from '../../../types/apiTypes'

const toObject = (label: string, value: string) => ({ value, label })

export type TLoadingMethodsOptions = 'ltl' | 'ftl' | 'intermodal' | 'all'

export type TInsightsSectionsNames = 'overview' | 'facilities' | 'dataDownload'

type DateFilterType = FacilitiesQueryParams['dateFilter']

export const INSIGHTS_PAGE_TABS_LABELS: Record<TInsightsSectionsNames, string> = {
  overview: 'Overview',
  facilities: 'Facilities',
  dataDownload: 'Data Download',
}

export const INSIGHTS_PAGE_TABS_URLS: Record<TInsightsSectionsNames, string> = {
  overview: 'overview',
  facilities: 'facilities',
  dataDownload: 'data-download',
}

export const PICKUP_LOCATIONS_DEFAULT = {
  id: 'all',
  text: 'All Pickup Locations',
  groupIndex: -1,
} as IAutocompleteBaseOption

export const DELIVERY_LOCATIONS_DEFAULT = {
  id: 'all',
  text: 'All Delivery Locations',
  groupIndex: -1,
} as IAutocompleteBaseOption

export const FACILITIES_DEFAULT = {
  id: 'all',
  text: 'All Facilities',
  groupIndex: -1,
} as IAutocompleteBaseOption

export const MODES_DEFAULT = {
  value: 'all',
  label: 'All Modes',
} as TSelectOpt
export const MODES = [MODES_DEFAULT, ...MODE_OPTIONS_INTERMODAL]

export const LOADING_METHODS_DEFAULT = {
  value: 'all',
  label: 'All Loading Methods',
} as TSelectOpt
export const LOADING_METHODS = [LOADING_METHODS_DEFAULT, ...LOADING_METHOD_OPTIONS]

export const DATE_FILTER_DEFAULT = {
  dateFilter: DATE_RANGE_OPTIONS[0].value as DateFilterType,
  startAt: undefined,
  endAt: undefined,
}

export enum OVERVIEW_COVERAGE_TYPES {
  'auction' = 'Auction',
  'routing_guide' = 'Routing Guide',
  'direct_assignment' = 'Direct Tender',
}

export const COVERAGE_TYPE_OPTIONS = $enum(OVERVIEW_COVERAGE_TYPES).map(toObject)
